import React from 'react';

const InvitationIntro = () => {
  return (
    <div className="flex flex-col bg-[#52340A]">
      <div
        className="w-full bg-full h-[15.4375rem] bg-no-repeat relative"
        style={{
          backgroundImage: `url(${require('@/assets/imgs/invitation/invite-pic-1.webp')})`,
        }}>
        <div className="w-full h-[34px] absolute bottom-0 bg-gradient-to-b from-transparent to-[#52340A]"></div>
      </div>
      <div className="mt-1.5 p-3">
        <div
          className="w-full h-[28.625rem] bg-full bg-no-repeat"
          style={{
            backgroundImage: `url(${require('@/assets/imgs/invitation/invite-pic-2.webp')})`,
          }}
        />
        <div
          className="w-full h-[36.6875rem] bg-full bg-no-repeat mt-6"
          style={{
            backgroundImage: `url(${require('@/assets/imgs/invitation/invite-pic-3.webp')})`,
          }}
        />
        <div
          className="w-full h-[24.1875rem] bg-full bg-no-repeat mt-6"
          style={{
            backgroundImage: `url(${require('@/assets/imgs/invitation/invite-pic-4.webp')})`,
          }}
        />
        <div
          className="w-full h-[20.125rem] bg-full bg-no-repeat mt-6"
          style={{
            backgroundImage: `url(${require('@/assets/imgs/invitation/invite-pic-5.webp')})`,
          }}
        />
        <div
          className="w-full h-[42.9375rem] bg-full bg-no-repeat mt-6"
          style={{
            backgroundImage: `url(${require('@/assets/imgs/invitation/invite-pic-6.webp')})`,
          }}
        />
      </div>
    </div>
  );
};

export default InvitationIntro;
